import React, { useEffect, useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { FileText, Zap, Globe, Users, BookOpen, ShieldCheck, Lock, CreditCard, Clock } from 'lucide-react';
function MiniCountdown() {
  const [totalSeconds, setTotalSeconds] = useState(23 * 3600 + 59 * 60 + 59);
  useEffect(() => {
    const interval = setInterval(() => {
      setTotalSeconds(s => s <= 0 ? 0 : s - 1);
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor(totalSeconds % 3600 / 60);
  const secs = totalSeconds % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const total = 23 * 3600 + 59 * 60 + 59;
  const progress = (total - totalSeconds) / total * 100;
  return <div className="w-full bg-burgundy text-white py-1.5 px-3 flex items-center justify-center gap-2 text-xs font-semibold" data-id="element-121">
      <Clock size={12} data-id="element-122" />
      <span data-id="element-123">
        🔥 Oferta limitada — termina en {pad(hrs)}:{pad(mins)}:{pad(secs)}
      </span>
      <div className="w-16 h-1.5 bg-white/20 rounded-full overflow-hidden ml-1" data-id="element-124">
        <div className="h-full bg-gold rounded-full transition-all duration-1000" style={{
        width: `${progress}%`
      }} data-id="element-125" />
      </div>
    </div>;
}
export function HeroSection() {
  return <SectionWrapper className="text-center pt-0 md:pt-0 pb-16 !px-0" data-id="element-126">
      <MiniCountdown data-id="element-127" />
      <div className="px-4 md:px-8 pt-6 md:pt-8" data-id="element-128">
        <div className="inline-block mb-3" data-id="element-129">
          <span className="text-4xl md:text-5xl" data-id="element-130">🌟</span>
        </div>

        <h1 className="text-5xl md:text-7xl font-black text-burgundy mb-2 tracking-tight" data-id="element-131">
          CÓDIGO HIJO
        </h1>

        <p className="text-xl md:text-3xl font-serif text-text-main mb-8 italic" data-id="element-132">
          Todo el manual de tu hijo. Resuelto.
        </p>

        <div className="max-w-3xl mx-auto mb-10" data-id="element-133">
          <h2 className="text-2xl md:text-4xl font-serif text-text-main leading-tight mb-8" data-id="element-134">
            "Listo para leer. Sin adivinar más.{' '}
            <br className="hidden md:block" data-id="element-135" />
            Sin improvisar. Sin noches de culpa."
          </h2>

          {/* Mockup Image */}
          <div className="mb-10" data-id="element-136">
            <img src="https://cdn.magicpatterns.com/uploads/36KyJtAWQCaee1C1MniP2Z/hf_20260404_154204_e2e77d59-4aa3-4d1a-b9cb-2d1360793da1.png" alt="Código Hijo — Manual Maestro Mega Pack" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-137" />
          </div>

          <p className="text-lg md:text-xl text-text-main/80 leading-relaxed" data-id="element-138">
            El sistema para mamás que quieren entender a su hijo desde su diseño
            único: año completo de herramientas listas (personalidad + emociones
            + aprendizaje + comunicación + límites + conexión profunda), sin
            buscar ni armar desde cero.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-1.5 md:gap-3 mb-10" data-id="element-139">
          <Badge icon={<FileText size={12} data-id="element-141" />} text="PDF Digital" data-id="element-140" />
          <Badge icon={<Zap size={12} data-id="element-143" />} text="Acceso Inmediato" data-id="element-142" />
          <Badge icon={<Globe size={12} data-id="element-145" />} text="Español Latino" data-id="element-144" />
          <Badge icon={<Users size={12} data-id="element-147" />} text="Todos los niveles" data-id="element-146" />
          <Badge icon={<BookOpen size={12} data-id="element-149" />} text="6 Tomos + 3 Bonus" data-id="element-148" />
        </div>

        <div className="flex flex-col items-center" data-id="element-150">
          <a href="#pricing" className="bg-burgundy text-white text-lg md:text-xl font-bold py-4 md:py-5 px-8 md:px-12 rounded-full shadow-lg hover:bg-burgundy/90 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 w-full md:w-auto text-center" data-id="element-151">
            💛 QUIERO MI CÓDIGO HIJO AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-text-main/70 font-medium" data-id="element-152">
            <span className="flex items-center gap-1" data-id="element-153">
              <ShieldCheck size={16} className="text-green-600" data-id="element-154" /> Garantía 7
              días sin preguntas
            </span>
            <span className="flex items-center gap-1" data-id="element-155">
              <Lock size={16} className="text-gray-600" data-id="element-156" /> Pago 100% seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-157">
              <CreditCard size={16} className="text-blue-600" data-id="element-158" /> Paga en tu
              moneda local
            </span>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}
function Badge({
  icon,
  text
}: {
  icon: React.ReactNode;
  text: string;
}) {
  return <div className="flex items-center gap-1.5 bg-card-bg px-2.5 py-1 rounded-full shadow-sm border border-dusty-rose/20 text-xs font-medium text-text-main" data-id="element-159">
      <span className="text-gold" data-id="element-160">{icon}</span>
      {text}
    </div>;
}